angular.module('common')
    .factory('authFactory',['$http', function($http) {
            var authFactory = {};

            authFactory.logOut = function() {
                localStorage.clear();
            };

            authFactory.login = function (credentials) {
                return $http.post('/token', credentials);
            }

            authFactory.getUser = function(token) {
                return $http.get('/api/user/',
                {
                    headers: {
                        'Authorization': 'Bearer ' + token
                    }
                });
            };

            authFactory.getUserWithCreds = function (token, credentials) {
                return $http.post('/api/userwithcreds/', { Credentials: credentials },
                    {
                        headers: {
                            'Authorization': 'Bearer ' + token
                        }
                    });
            };

            authFactory.getCreds = function () {
                var authenticationRefreshData = localStorage.getItem("authenticationRefreshData");
                if (authenticationRefreshData != null) {
                    return $http.post('/api/getcreds', { CredsKey: JSON.parse(authenticationRefreshData).credsKey });
                }
            };

            authFactory.GetAuthenticationData = function() {
                var authenticationData = localStorage.getItem("authenticationData");
                return JSON.parse(authenticationData);
            }

            authFactory.init2ndFactor = function(credentials) {
                return $http.post('/api/login/init', credentials);
            }

            authFactory.verify2ndFactor = function (credentials) {
                return $http.post('/api/login/verify', credentials);
            }

            authFactory.getTwoFactorConfig = function () {
                return $http.get('/api/login/twofactor');
            }

            return authFactory;
        }
    ]);